import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
const NotFoundErrorWrapper: FC = ({}) => {
  const t = useTranslations();
  return <>
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8 text-center">
                        <div className="error-page">
                            <div className="display-1 text-danger" aria-hidden="true">500</div>
                            <h1 className="mb-4">{t('notFound.error.title')}</h1>
                            <p className="lead mb-4">
                                {t('notFound.error.desc')}
                            </p>
                             <div className="d-flex justify-content-center gap-3">
                                <Link href="/" className="btn btn-primary" data-sentry-element="Link" data-sentry-source-file="notFoundErrorWrapper.tsx">
                                     {t('notFound.backHome')}
                                </Link>
                                <Link href="/workspaces" className="btn btn-outline-primary" data-sentry-element="Link" data-sentry-source-file="notFoundErrorWrapper.tsx">
                                    {t('notFound.browseWorkspaces')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>;
};
export default NotFoundErrorWrapper;